import { fetchContactInfoService } from "./fetchContactInfo";

export const checkoutServices = {
  fetchContactInfoService,
};
